"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmeraldModalCoreInputs = void 0;
const id = `${Math.floor(Math.random() * 10000)}`;
class EmeraldModalCoreInputs {
    constructor() {
        this.id = id;
        this.opened = false;
        this.closeOnEscape = true;
        this.closeOnOutsideClick = true;
        this.hasCloseIcon = false;
        this.contentId = `content-${id}`;
        this.titleId = `title-${id}`;
    }
}
exports.EmeraldModalCoreInputs = EmeraldModalCoreInputs;
//# sourceMappingURL=modal.inputs.js.map